module.exports = __webpack_public_path__ + "img/pull_out_basket_fabrik.8ceeb4db.png";